import React, { memo, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Controller } from 'react-hook-form';
import DropDown, { DropDownItem } from '../DropDown';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Box from '@material-ui/core/Box/Box';

const useStyles = makeStyles(theme => ({
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(.5, 2),
  },
  fieldLabel: {
    flexShrink: 0,
    width: 160,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
}), { name: 'SingleSelectInput' });

function SingleSelectInput({ name, control, label, selectionMessage = 'Select...', options = [] }: EvaluationFieldProps) {
  const classes = useStyles();
  const items: DropDownItem[] = useMemo(
    () => options.map(opt => ({ value: opt, content: opt })),
    [options],
  );

  const emptyItem: DropDownItem = useMemo(
    () => ({ value: '', content: selectionMessage }),
    [selectionMessage],
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <Box className={classes.inputWrapper}>
          <Box className={classes.fieldLabel}>{label}:</Box>
          <DropDown
            items={items}
            value={value || ''}
            emptyItem={emptyItem}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Box>
      )}
    />
  );
}

export default memo(SingleSelectInput);
